import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import GuidePage from "./components/GuidePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/modguide" element={<GuidePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
